<template>
  <div id="app">
    <!-- <img
      class="image"
      src="https://vehicle-library.oss-cn-beijing.aliyuncs.com/cvbd-icon/evaluation/job_cert_reverse_20250121.jpg"
      alt
    />
    <img
      class="back_img"
      @click="call_back"
      src="../../assets/backs.png"
      alt=""
    /> -->
    <wx-open-launch-weapp
      appid="wxfe62c54ae0214d03"
      username="gh_8105ad995704"
      path="pages/userLogin/userLogin"
      @launch="handleLaunchFn"
      @error="handleErrorFn"
    >
      <template>
        <button class="btn" @click="initWeChatSDK">打开小程序</button>
      </template>
    </wx-open-launch-weapp>
  </div>
</template>


<script>
import QRCode from "qrcode";
import wx from "weixin-js-sdk";
export default {
  // 组件名称
  name: "demo",
  data() {
    return {
      isWeChatBrowser: false,
      obj: {
        userName: "车萍萍",
        station: "二手商用车鉴定评估师",
        stationLevel: "中级",
        certificateNo: "20150101235959999001",
        firstPicture: "",
        secondPicture: "",
        ateIssueTime: "2015-01-01",
      },
      url: "https://h5.chinaucv.com/defaultEva",
    };
  },
  mounted() {},
  methods: {
    handleLaunchFn(e) {
      console.log(123123123);
      console.log("success");
    },

    handleErrorFn(e) {
      console.log(123123123);
      console.log("fail", e);
    },
    checkWeChatBrowser() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.includes("micromessenger");
    },
    // 初始化微信 JSSDK
    initWeChatSDK() {
      const configData = {
        debug: true,
        appId: "wxfe62c54ae0214d03", // 必填，公众号的唯一标识
        timestamp: "1756539722", // 必填，生成签名的时间戳
        nonceStr: "Wm3WZYTPz0wzccnW", // 必填，生成签名的随机串
        signature: "e4ff5bd89b60ea6c0fa40c1ab604a22ec3619461", // 必填，签名
        jsApiList: [
          "checkJsApi",
          "navigateToMiniProgram",
          "wx-open-launch-weapp",
        ], // 必填，需要使用的JS接口列表
        openTagList: ["wx-open-launch-weapp"], // 填入打开小程序的开放标签名
      };
      wx.config(configData);

      wx.ready((res) => {
        console.log("init-r -> 微信SDK准备就绪后执行的回调", res);
        this.handleLaunchFn()
        this.handleErrorFn()
        // wx.checkJsApi({
        //   jsApiList: ["wx-open-launch-app"], // 校验跳转APP的标签是否可用
        //   success: function (res) {
        //     console.log("可用");
        //   },
        //   fail: (err) => {
        //     console.log(err, "不可用");
        //   },
        // });
        // this.redirectToWeChatMiniProgram();
      });

      wx.error((err) => {
        console.error("微信 JSSDK 配置错误:", err);
      });
    },
    // 跳转到微信小程序
    redirectToWeChatMiniProgram() {
      wx.miniProgram.navigateTo({
        appId: "wxfe62c54ae0214d03", // 必填，小程序的唯一标识
        url: "/pages/userLogin/userLogin",
        envVersion: "release",
        success(e) {
          console.log(e);
          console.log("成功跳转到小程序");
        },
        fail(err) {
          console.error("跳转到小程序失败", err);
        },
      });
    },
    call_back() {
      this.isWeChatBrowser = this.checkWeChatBrowser();
      if (this.isWeChatBrowser) {
        this.initWeChatSDK();
      } else {
        //正式版为release，体验版为trial，开发版为develop，仅在微信外打开时生效。注意：若不填写，则默认打开正式版小程序。
        window.location.href =
          "weixin://dl/business/?appid=wxfe62c54ae0214d03&path=pages/newindex/newindex&env_version=release";
      }
      // this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
body {
  width: 100%;
  background: #f8f8f8;
}

.image {
  /* width: 7.5rem; */
  width: 100%;
  height: 593px;
}

.imageView {
  margin-bottom: 10px;
  width: 100%;
  height: 593px;
  background: url("https://vehicle-library.oss-cn-beijing.aliyuncs.com/cvbd-icon/evaluation/job_cert_font_20250121.jpg")
    center center no-repeat;
  background-size: 100%;
  overflow: hidden;
}

.imageViewMargin {
  width: 146px;
  height: 204px;
  margin: 140px auto 20px;
  position: relative;
}

.imageViewMargin > img {
  width: 100%;
  height: 100%;
}

.wrapperFlex {
  width: 300px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  padding: 5px 0;
}

.wrapperFlexLeft {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #241915;
  width: 95px;
}

.wrapperRight {
  flex: 1;
  font-size: 15px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #241915;
}

.wrapperErWei {
  width: 76px;
  height: 76px;
  float: left;
}

.wrapperErWei > img {
  width: 100%;
  height: 100%;
}

.wrapperErWeiRight {
  font-size: 13px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #241915;
  position: absolute;
  bottom: 0;
  right: 24px;
}

.wrapperErWeiRightFlex {
  display: flex;
}

.back_img {
  width: 40px;
  height: 40px;
  position: fixed;
  right: 10px;
  bottom: 150px;
  z-index: 99999999;
}
</style>
